import axios from "@/app/Axios";
 /*MOSTRAR NUEVO REGISTRO *************************/

class FormEditar {
  async formEditar() {
    try {
      const response = await axios.get("/formEditar")
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return error.response.data;
      } else {
        console.log(error);
        
      }
    }
  }
    /*AGREGAR NUEVO REGISTRO *************************/
  
    async saveData(formEditar) {
      try {
        const response = await axios.post("/formEditarspost", formEditar);
        console.log("Update request:", response.config); // Imprime la solicitud
        console.log("Update response:", response.data); // Imprime la respuesta
        return response.data;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          return error.response.data;
        } else {
          console.log(error);
        }
      }
    }
      /*EDITAR REGISTRO ****************************************************/

  async updateData(formEditar) {
    try {
      const response = await axios.put(`/formEditarput/${formEditar.id}`,formEditar);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return error.response.data;
      } else {
        console.log(error);
      }
    }
  }

  /* ELIMINAR REGISTRO **************************************************/

  async deleteData(id) {
    try {
      const response = await axios.delete(`/formEditardelete/${id}`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return error.response.data;
      } else {
        console.log(error);
      }
    }
  }


}
export default FormEditar
